import  PartnerOpen from './PartnerOpen';
export default PartnerOpen
